import React, { useState, useEffect } from 'react';

// SVG brand logos
const PlatformLogo: React.FC<{ platform: string; size?: number }> = ({ platform, size = 28 }) => {
  const s = size;
  switch (platform) {
    case 'facebook':
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" fill="#1877F2">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      );
    case 'instagram':
      return (
        <svg width={s} height={s} viewBox="0 0 24 24">
          <defs>
            <linearGradient id="ig" x1="0%" y1="100%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#f09433"/>
              <stop offset="25%" stopColor="#e6683c"/>
              <stop offset="50%" stopColor="#dc2743"/>
              <stop offset="75%" stopColor="#cc2366"/>
              <stop offset="100%" stopColor="#bc1888"/>
            </linearGradient>
          </defs>
          <path fill="url(#ig)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      );
    case 'linkedin':
      return (
        <svg width={s} height={s} viewBox="0 0 24 24" fill="#0A66C2">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      );
    case 'google_my_business':
      return (
        <svg width={s} height={s} viewBox="0 0 24 24">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
      );
    case 'pinterest':
      return <svg width={s} height={s} viewBox="0 0 24 24" fill="#BD081C"><path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/></svg>;
    case 'tiktok':
      return <svg width={s} height={s} viewBox="0 0 24 24" fill="#000"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>;
    case 'youtube':
      return <svg width={s} height={s} viewBox="0 0 24 24" fill="#FF0000"><path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/></svg>;
    default:
      return <span style={{ fontSize: s * 0.8 }}>🌐</span>;
  }
};

// LinkedIn type modal
const LinkedInTypeModal: React.FC<{
  onSelect: (type: 'personal' | 'company') => void;
  onClose: () => void;
}> = ({ onSelect, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
    <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4">
      <div className="flex items-center gap-3 mb-1">
        <PlatformLogo platform="linkedin" size={24} />
        <h2 className="text-lg font-semibold text-gray-900">Connecter LinkedIn</h2>
      </div>
      <p className="text-sm text-gray-400 mb-6 ml-9">Quel type de compte souhaitez-vous connecter ?</p>
      <div className="space-y-3 mb-6">
        <button
          onClick={() => onSelect('personal')}
          className="w-full flex items-center gap-4 p-4 border border-gray-200 rounded-xl hover:border-[#0A66C2] hover:bg-blue-50 transition-all group text-left"
        >
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#0A66C2"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg>
          </div>
          <div>
            <p className="font-medium text-gray-900 group-hover:text-[#0A66C2] text-sm">Profil personnel</p>
            <p className="text-xs text-gray-400 mt-0.5">Publiez sur votre profil LinkedIn</p>
          </div>
        </button>
        <button
          onClick={() => onSelect('company')}
          className="w-full flex items-center gap-4 p-4 border border-gray-200 rounded-xl hover:border-[#0A66C2] hover:bg-blue-50 transition-all group text-left"
        >
          <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#0A66C2"><path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/></svg>
          </div>
          <div>
            <p className="font-medium text-gray-900 group-hover:text-[#0A66C2] text-sm">Page entreprise</p>
            <p className="text-xs text-gray-400 mt-0.5">Gérez votre page LinkedIn entreprise</p>
          </div>
        </button>
      </div>
      <button onClick={onClose} className="w-full text-sm text-gray-400 hover:text-gray-600 transition-colors">
        Annuler
      </button>
    </div>
  </div>
);

interface SocialPlatform {
  platform: string;
  name: string;
  icon: string;
  color: string;
  description: string;
  features: string[];
  available: boolean;
}

interface SocialAccount {
  id: number;
  platform: string;
  platform_username: string;
  platform_name: string;
  account_type: string;
  sync_status: string;
  is_active: boolean;
  created_at: string;
  last_sync?: string;
}

const SocialNetworksPage: React.FC = () => {
  const [platforms, setPlatforms] = useState<SocialPlatform[]>([]);
  const [connectedAccounts, setConnectedAccounts] = useState<SocialAccount[]>([]);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState<string | null>(null);
  const [showLinkedInModal, setShowLinkedInModal] = useState(false);
  const [disconnecting, setDisconnecting] = useState<number | null>(null);

  useEffect(() => {
    fetchPlatformsAndAccounts();
  }, []);

  const fetchPlatformsAndAccounts = async () => {
    try {
      setLoading(true);
      const [platformsRes, accountsRes] = await Promise.all([
        fetch('/api/social/platforms'),
        fetch('/api/social/accounts', {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
        })
      ]);
      const platformsData = await platformsRes.json();
      const accountsData = await accountsRes.json();
      setPlatforms(platformsData.platforms || []);
      setConnectedAccounts(accountsData.accounts || []);
    } catch (error) {
      console.error('Failed to fetch social data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnect = async (platform: string, linkedInType?: 'personal' | 'company') => {
    try {
      setConnecting(platform);
      const url = linkedInType
        ? `/api/social/connect/${platform}?type=${linkedInType}`
        : `/api/social/connect/${platform}`;
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      const data = await response.json();
      if (data.success) {
        window.location.href = data.auth_url;
      } else {
        throw new Error(data.message || 'Failed to initiate connection');
      }
    } catch (error) {
      console.error(`Failed to connect ${platform}:`, error);
      alert(`Erreur lors de la connexion à ${platform}.`);
    } finally {
      setConnecting(null);
    }
  };

  const handleDisconnect = async (accountId: number, platformName: string) => {
    if (!confirm(`Déconnecter ce compte ${platformName} ?`)) return;
    try {
      setDisconnecting(accountId);
      const response = await fetch(`/api/social/disconnect/${accountId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
      });
      const data = await response.json();
      if (data.success) {
        fetchPlatformsAndAccounts();
      } else {
        throw new Error(data.message || 'Failed to disconnect');
      }
    } catch (error) {
      console.error(`Failed to disconnect ${platformName}:`, error);
    } finally {
      setDisconnecting(null);
    }
  };

  const getAccountForPlatform = (platform: string): SocialAccount | null => {
    const active = connectedAccounts.filter(a => a.platform === platform);
    return active.length > 0 ? active[0] : null;
  };

  const getAccountTypeLabel = (account: SocialAccount, platform: string) => {
    if (account.account_type === 'page') return 'Page';
    if (account.account_type === 'business') return 'Fiche Business';
    if (platform === 'instagram') return 'Compte Business';
    if (platform === 'linkedin' && account.account_type === 'personal') return 'Profil personnel';
    if (platform === 'linkedin') return 'Page entreprise';
    return 'Compte personnel';
  };

  const connectedCount = connectedAccounts.length;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-200 border-t-indigo-600"></div>
          <p className="text-sm text-gray-400">Chargement...</p>
        </div>
      </div>
    );
  }

  const availablePlatforms = platforms.filter(p => p.available);

  return (
    <div className="max-w-5xl mx-auto space-y-8 pb-10">
      {showLinkedInModal && (
        <LinkedInTypeModal
          onSelect={(type) => { setShowLinkedInModal(false); handleConnect('linkedin', type); }}
          onClose={() => setShowLinkedInModal(false)}
        />
      )}

      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Réseaux sociaux</h1>
        <p className="text-sm text-gray-500 mt-1">Connectez vos comptes pour publier et gérer votre présence en ligne.</p>
      </div>

      {/* Stats bar */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
          <p className="text-2xl font-bold text-gray-900">{connectedCount}</p>
          <p className="text-xs text-gray-400 mt-0.5">Compte{connectedCount > 1 ? 's' : ''} connecté{connectedCount > 1 ? 's' : ''}</p>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm">
          <p className="text-2xl font-bold text-gray-900">{availablePlatforms.length}</p>
          <p className="text-xs text-gray-400 mt-0.5">Plateformes disponibles</p>
        </div>
      </div>

      {/* Available platforms */}
      <div>
        <h2 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Plateformes disponibles</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {availablePlatforms.map((platform) => {
            const account = getAccountForPlatform(platform.platform);
            const isConnected = !!account;
            const isConnecting = connecting === platform.platform;
            const isDisc = account && disconnecting === account.id;

            return (
              <div
                key={platform.platform}
                className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden hover:shadow-md transition-shadow"
              >
                {/* Color bar */}
                <div className="h-1" style={{ backgroundColor: platform.color }} />

                <div className="p-5">
                  {/* Platform header */}
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: platform.color + '15' }}>
                        <PlatformLogo platform={platform.platform} size={22} />
                      </div>
                      <div>
                        <h3 className="font-semibold text-gray-900 text-sm">{platform.name}</h3>
                        <p className="text-xs text-gray-400">{platform.description}</p>
                      </div>
                    </div>
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
                      isConnected
                        ? 'bg-emerald-50 text-emerald-700'
                        : 'bg-gray-100 text-gray-500'
                    }`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${isConnected ? 'bg-emerald-500' : 'bg-gray-400'}`} />
                      {isConnected ? 'Connecté' : 'Non connecté'}
                    </span>
                  </div>

                  {/* Connected account info */}
                  {isConnected && account && (
                    <div className="mb-4 flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2.5">
                      <div className="flex items-center gap-2.5">
                        <div
                          className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
                          style={{ backgroundColor: platform.color }}
                        >
                          {account.platform_name?.charAt(0)?.toUpperCase() || '?'}
                        </div>
                        <div>
                          <p className="text-sm font-medium text-gray-900 leading-tight">{account.platform_name}</p>
                          <p className="text-xs text-gray-400">{getAccountTypeLabel(account, platform.platform)}</p>
                        </div>
                      </div>
                      <button
                        onClick={() => handleDisconnect(account.id, platform.name)}
                        disabled={!!isDisc}
                        className="text-xs text-gray-400 hover:text-red-500 transition-colors disabled:opacity-50 px-2 py-1 rounded hover:bg-red-50"
                      >
                        {isDisc ? '...' : 'Retirer'}
                      </button>
                    </div>
                  )}

                  {/* Action button */}
                  {platform.platform === 'instagram' ? (
                    isConnected ? (
                      <button
                        onClick={() => handleConnect('facebook')}
                        disabled={connecting === 'facebook'}
                        className="w-full py-2 text-xs font-medium rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors"
                      >
                        Reconnecter via Facebook
                      </button>
                    ) : getAccountForPlatform('facebook') ? (
                      <button
                        onClick={() => handleConnect('facebook')}
                        disabled={connecting === 'facebook'}
                        className="w-full py-2 text-xs font-medium rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors"
                      >
                        Reconnecter Facebook pour détecter Instagram
                      </button>
                    ) : (
                      <div className="w-full py-2.5 px-3 text-xs text-center text-gray-400 bg-gray-50 rounded-lg border border-dashed border-gray-200">
                        Connectez d'abord Facebook — Instagram se détecte automatiquement
                      </div>
                    )
                  ) : isConnected ? (
                    <button
                      onClick={() => platform.platform === 'linkedin' ? setShowLinkedInModal(true) : handleConnect(platform.platform)}
                      disabled={isConnecting}
                      className="w-full py-2 text-xs font-medium rounded-lg border border-gray-200 text-gray-500 hover:bg-gray-50 transition-colors"
                    >
                      Changer de compte
                    </button>
                  ) : (
                    <button
                      onClick={() => platform.platform === 'linkedin' ? setShowLinkedInModal(true) : handleConnect(platform.platform)}
                      disabled={isConnecting}
                      className="w-full py-2.5 text-sm font-medium rounded-lg text-white transition-all hover:opacity-90 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                      style={{ backgroundColor: platform.color }}
                    >
                      {isConnecting ? (
                        <>
                          <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                          </svg>
                          Connexion...
                        </>
                      ) : (
                        <>
                          <PlatformLogo platform={platform.platform} size={16} />
                          Connecter {platform.name}
                        </>
                      )}
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

    </div>
  );
};

export default SocialNetworksPage;
